"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopupRef = void 0;
const store_1 = require("../store");
const usePopupRef = () => {
    const state = (0, store_1.useTrackedState)();
    return state.popupRef;
};
exports.usePopupRef = usePopupRef;
